var giphy_viewer_default = {
  "giphy_player": "_--SCI",
  "gifRatio": "vvk7P"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
